import "@/style/information.scss"
import "@/utils/nav";
import "@/utils/tab.js"
import "@/utils/website.js"

let idList = ''
let current = 1

// 查询动态资讯id
$.ajax({
  url: '/api/admin/official/exc/infoDynamic',
  type: 'GET',
  dataType: 'json',
  success: function (res) {
    idList = res.data.infoIdList
  }
})

setTimeout(() => {
  getData()
}, 200);


function setReslutDom(records) {
  let html = "";
  records.forEach((v) => {
    if (v.linkType === 0 || v.linkType === null) {
      html += `
          <div class="search-result_item">
            <text class="search-result_item--title">
              <a href="informationDetail.html?idx=0&id=${encodeURI(v.id)}&nav=${encodeURI('资讯动态')}">${v.title}</a>
            </text>
            <text class="search-result_item--time">${v.publicTime}</text>
          </div>
          `;
    } else {
      html += `
          <div class="search-result_item">
            <text class="search-result_item--title">
              <a href="${v.linkUrl}" target="_blank">${v.title}</a>
            </text>
            <text class="search-result_item--time">${v.publicTime}</text>
          </div>
          `;
    }

  });
  $("#information-list").append(html);
}

// 加载更多
$(document).ready(function () {
  $(".more").click(function () {
    current += 1
    getData()
  })
})

function getData() {
  $.ajax({
    url: `/api/admin/official/exc/information/detailByIds?current=${current}&size=10`,
    type: 'POST',
    contentType: 'application/json; charset=UTF-8',
    processData: false,
    data: JSON.stringify(idList),
    dataType: 'json',
    success: function (res) {
      console.log('res--->', res)
      const d = res.data.records;
      if (res.data.pages == current) {
        $(".more").hide()
      }
      if (d.length > 0) {
        setReslutDom(d);
      } else {
      }
    }
  })
}
// current: 1
// pages: 98
// records: [{id: 2361, createBy: 1, createTime: "2022-06-30 17:36:59", updateBy: 1,…},…]
// size: 12
// total: 1170
